import { SidebarService } from './sidebar.service';
import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { isMobile } from '../utils/device.utils';

@Component({
  selector: 'sidebar',
  standalone: true,
  imports: [NgClass],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  @Input() title: string = '';

  constructor(private readonly service: SidebarService) {}

  close() {
    this.service.closeSide();
  }

  protected readonly isMobile = isMobile;
}
